import styled from 'styled-components'
import { Theme } from 'styles/Themes'

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;

  .detalhes-captacao-title {
    width: 100%;
    height: 24px;
    color: var(--Preto-Principal, #1c1d22);
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.2px;

    margin-bottom: 8px;
  }

  .detalhes-captacao-subtitle {
    color: #000;

    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;

    margin-bottom: 16px;
  }

  .status-card-captacao {
    display: flex;
    align-items: center;
    color: #00cd52;

    gap: 10px;
    margin-bottom: 8px;

    width: 100%;
    height: 26px;

    font-family: 'Roboto';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 26px; /* 185.714% */
    letter-spacing: 0.2px;
  }

  .status-card-captacao-img {
    width: 16px;
    height: 16px;
    filter: ${Theme.icons.QUATERNARY};
    margin-bottom: 5px;
  }

  .status-card-container-cards {
    display: flex;
    width: 70%;
    flex-wrap: wrap;
    gap: 16px 20px;
    margin-left: 1px;
    padding-bottom: 32px;
  }

  .detalhes-container123 {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .detalhes-edit-icon {
    width: 16px;
    height: 16px;

    margin-bottom: 16px;
  }

  .detalhes-botoes-container {
    display: flex;
    align-items: center;
    gap: 32px;
  }
`
export const CheckboxesContainer = styled.div`
  display: flex;
  gap: 32px;
  margin-bottom: 30px;
`

export const ShowToolTipContainer = styled.div`
  display: flex;
  gap: 8px;
  position: relative;
  align-items: center;
  .icon {
    width: 16px;
    height: 16px;
  }
  .tooltip {
    display: inline-block;
    visibility: hidden;
    position: absolute;
    top: -40px;
    right: 0;
    background-color: black;
    color: #fff;
    display: flex;
    padding: 4px 8px;
    flex-direction: column;
    border-radius: 4px;
  }
  .tooltip::after {
    content: ' ';
    position: absolute;
    top: 100%; /* At the bottom of the tooltip */
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: black transparent transparent transparent;
  }
  .tooltip-txt {
    font-weight: 400;
    font-size: 10px;
    line-height: 13.23px;
    text-align: center;
    font-family: Inter;
  }
  .bold {
    font-weight: 700;
  }

  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }
`
